import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import { ageGenderDHIS2SRHReportHeader } from "../components/HeaderAttribute";
import jsPDF from "jspdf";
import "jspdf-autotable";
import fpaiLogo from "../image/FPAILogo.jpg";
import MultiSelect from "../ReusableComponents/MultiSelect";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import Loader from "../ReusableComponents/Loader";
const AgeGenderDHIS2SRH = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [branchName, setBranchName] = useState("");
  const [project, setProject] = useState("");
  const [bindProjectDD, setBindProjectDD] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


  const [ageGenderFields, setAgeGenderFields] = useState({
    branchProject: "",
    sdp: "",
    area: "",
    serviceCategory: "",
    serviceSubCategory: "",
    servicesName: "",
  });
  const [ageGenderFieldsError, setAgeGenderFieldsError] = useState({
    sdpError: "",
    areaError: "",
    branchProjectError: "",

    serviceCategoryError: "",
    serviceSubCategoryError: "",
    servicesNameError: "",
  });

  const [showTable, setShowTable] = useState(false);

  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);
  const [getServicesData, setGetServicesDatas] = useState([]);
  const [getServiceSubCDatas, setGetServiceSubCDatas] = useState([]);
  const [bindServicesName, setBindServicesName] = useState([]);
  const [bindServiceSubCategory, setBindServiceSubCategory] = useState([]);
  const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
  const [bindAgeGenderDHIS2SRHData, setBindAgeGenderDHIS2SRHData] = useState(
    []
  );
  const [bindServiceCategory, setBindServiceCategory] = useState([]);

  const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);
  const [sdpNamesList, setSDPNamesList] = useState([]);
  const [areaNamesList, setAreaNamesList] = useState([]);
  const [serviceCategoryNameList, setServiceCategoryNameList] = useState([]);
  const [serviceSubCategoryNameList, setServiceSubCategoryNameList] = useState(
    []
  );
  const [serviceNameList, setServiceNameList] = useState([]);

  useEffect(() => {
    if (
      userProfileDatas[0]?.MstOrganizationId == 2 ||
      userProfileDatas[0]?.MstOrganizationId == 3
    ) {
      if (userProfileDatas[0]?.MstSDPId == null) {
        setAgeGenderFields({
          ...ageGenderFields,
          branchProject: [userProfileDatas[0]?.MstLocationId],
          sdp: "",
        });
        setBranchName(userProfileDatas[0]?.LocationName_en);
      } else {
        setAgeGenderFields({
          ...ageGenderFields,
          branchProject: [userProfileDatas[0]?.MstLocationId],
          sdp: [userProfileDatas[0]?.MstSDPId],
        });
        setBranchName(userProfileDatas[0]?.LocationName_en);
      }
    }
    BranchProjectFetchData();
    serviceCategoryDD();
    getProjectDDValues();
  }, [userProfileDatas ? userProfileDatas : undefined]);
  const getProjectDDValues = async () => {
    // Month Dropdown binding
    const userProfileDatas = userProfileState.userProfile;
    const [profile] = userProfileDatas;
    const data = {
      mstOrganizationStructureId: profile.MstOrganizationId,
      mstBranchId: profile.MstLocationId,
      mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
      mstUserId: profile.MstUserId,
      mstRoleId: profile.MstRoleId,
      languageCode: "en",
    };
    const response = await BindPostAPI([data], "MasterDataAPI/BindProject");
    const getTnxProjectId =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
          value: item.MstProjectId,
          label: item.ProjectName_en,
        }))
        : [];
    setBindProjectDD(getTnxProjectId);
  };
  const GoButton = async () => {
    setIsLoading(true);
    const branchProjectValidate = ageGenderFields.branchProject
      ? ""
      : "Select Branch/Project";
    const sdpValidate = ageGenderFields.sdp ? "" : "Select SDP";

    const areaValidate = ageGenderFields.area ? "" : "Select Area";

    const serviceCategoryValidate = ageGenderFields.serviceCategory
      ? ""
      : "Select Service Category";
    const serviceSubCategoryValidate = ageGenderFields.serviceSubCategory
      ? ""
      : "Select Service Sub-Category";
    const servicesNameValidate = ageGenderFields.servicesName
      ? ""
      : "Select  Services";
    setAgeGenderFieldsError({
      ...ageGenderFieldsError,
      branchProjectError: branchProjectValidate,
      sdpError: sdpValidate,
      areaError: areaValidate,
      serviceCategoryError: serviceCategoryValidate,
      serviceSubCategoryError: serviceSubCategoryValidate,
      servicesNameError: servicesNameValidate,
    });

    let branchProjectArray = Array.from(
      { length: ageGenderFields.branchProject.length },
      (v, i) => ageGenderFields.branchProject[i]
    );
    let branchProjectResult = branchProjectArray.join(",");

    let sdpArray = Array.from(
      { length: ageGenderFields.sdp.length },
      (v, i) => ageGenderFields.sdp[i]
    );
    let sdpResult = sdpArray.join(",");

    let areaArray = Array.from(
      { length: ageGenderFields.area.length },
      (v, i) => ageGenderFields.area[i]
    );
    let areaResult = areaArray.join(",");

    let serviceCategoryArray = Array.from(
      { length: ageGenderFields.serviceCategory.length },
      (v, i) => ageGenderFields.serviceCategory[i]
    );
    let serviceCategoryResult = serviceCategoryArray.join(",");

    let serviceSubCategoryArray = Array.from(
      { length: ageGenderFields.serviceSubCategory.length },
      (v, i) => ageGenderFields.serviceSubCategory[i]
    );
    let serviceSubCategoryResult = serviceSubCategoryArray.join(",");

    let servicesArray = Array.from(
      { length: ageGenderFields.servicesName.length },
      (v, i) => ageGenderFields.servicesName[i]
    );
    let servicesResult = servicesArray.join(",");

    if (
      !branchProjectValidate &&
      !sdpValidate &&
      !areaValidate &&
      !serviceCategoryValidate &&
      !serviceSubCategoryValidate &&
      !servicesNameValidate
    ) {
      const ReportData = [
        {
          mstBranchId: branchProjectResult,
          mstSDPId: sdpResult,
          mstAreaId: areaResult,
          mstServicesCategoryId: serviceCategoryResult,
          mstServicesSubCategoryId: serviceSubCategoryResult,
          mstServicesId: servicesResult,
          fromDate: fromDate,
          toDate: toDate,
          mstProjectId: project ? project : null,
        },
      ];
      const response = await BindPostAPI(
        ReportData,
        "TXNServicesAPI/ReportAgeGenderDHIS2SRH"
      );

      setBindAgeGenderDHIS2SRHData(response.data.Table);
      setShowTable(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  // const handleExport = () => {
  //   const dateRange = {
  //     fromDate: fromDate,
  //     toDate: toDate,
  //   };

  //   const selectedOptionsData = {
  //     branchProjectData:
  //       branchProjectNamesList.length > 0
  //         ? branchProjectNamesList.toString()
  //         : branchName,
  //     sdpData: sdpNamesList.toString(),
  //     areaData: areaNamesList.toString(),
  //     serviceCategoryData: serviceCategoryNameList.toString(),
  //     serviceSubCategoryData: serviceSubCategoryNameList.toString(),
  //     servicesData: serviceNameList.toString(),
  //   };

  //   exportData(
  //     ageGenderDHIS2SRHReportHeader.map((column) => column.title),
  //     bindAgeGenderDHIS2SRHData,
  //     dateRange,
  //     selectedOptionsData
  //   );
  // };

  const handleExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");

    try {
      const dateRange = {
        fromDate: fromDate,
        toDate: toDate,
      };

      const selectedOptionsData = {
        branchProjectData:
          branchProjectNamesList.length > 0
            ? branchProjectNamesList.toString()
            : branchName,
        sdpData: sdpNamesList.toString(),
        areaData: areaNamesList.toString(),
        serviceCategoryData: serviceCategoryNameList.toString(),
        serviceSubCategoryData: serviceSubCategoryNameList.toString(),
        servicesData: serviceNameList.toString(),
      };


      if (!bindAgeGenderDHIS2SRHData || bindAgeGenderDHIS2SRHData.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "AGE GENDER DHIS2 SRH REPORT",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: null,
            description: "No data available to export",
          },
          "Log/IUDLog"
        );

        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });

        return;
      }

      // ✅ SUCCESS LOG
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "AGE GENDER  SRH REPORT",
          action: "EXCEL EXPORT",
          status: "SUCCESS",
          tableName: null,
          description: `Age Gender DHIS2 SRH Report Excel exported successfully. Total Records: ${bindAgeGenderDHIS2SRHData.length}`,
        },
        "Log/IUDLog"
      );

      // ✅ EXPORT
      exportData(
        ageGenderDHIS2SRHReportHeader.map((column) => column.title),
        bindAgeGenderDHIS2SRHData,
        dateRange,
        selectedOptionsData
      );
    } catch (error) {
      console.error("Export error", error);

      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "AGE GENDER  SRH REPORT",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: null,
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog"
      );

      toast.error("Failed to export Excel", {
        duration: 1500,
        position: "top-center",
      });
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  useEffect(() => {
    if (ageGenderFields.branchProject) {
      const NameList = ageGenderFields.branchProject
        .map(
          (option) =>
            bindBranchProjectDD?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setBranchProjectNamesList(NameList);
    }

    if (ageGenderFields.sdp) {
      const NameList = ageGenderFields.sdp
        .map((option) => bindSDP?.find((item) => item.value === option)?.label)
        .filter(Boolean); // Remove undefined values if any
      setSDPNamesList(NameList);
    }

    if (ageGenderFields.area) {
      const NameList = ageGenderFields.area
        .map((option) => bindArea?.find((item) => item.value === option)?.label)
        .filter(Boolean); // Remove undefined values if any
      setAreaNamesList(NameList);
    }

    if (ageGenderFields.serviceCategory) {
      const NameList = ageGenderFields.serviceCategory
        .map(
          (option) =>
            bindServiceCategory?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceCategoryNameList(NameList);
    }

    if (ageGenderFields.serviceSubCategory) {
      const NameList = ageGenderFields.serviceSubCategory
        .map(
          (option) =>
            bindServiceSubCategory?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceSubCategoryNameList(NameList);
    }

    if (ageGenderFields.servicesName) {
      const NameList = ageGenderFields.servicesName
        .map(
          (option) =>
            bindServicesName?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceNameList(NameList);
    }
  }, [ageGenderFields]);



  const exportData = (columns, rows, dateRange, selectedDetails) => {
    const ageGroups = [
      "0to9",
      "10to14",
      "15to19",
      "20to24",
      "25to29",
      "30to34",
      "35to39",
      "40to44",
      "45to49",
      "50andAbove",
    ];

    /* ================= TITLE ROW ================= */
    const titleRow = [
      {
        v: "Age&Gender - SRH",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= DATE ROW ================= */
    const dateRangeRow = [
      { v: "" },
      { v: "From Date:", s: { font: { bold: true } } },
      { v: formatDate(dateRange.fromDate) },
      { v: "To Date:", s: { font: { bold: true } } },
      { v: formatDate(dateRange.toDate) },
    ];

    /* ================= FILTER ROWS ================= */
    const branchRow = [
      { v: "" },
      { v: "Branch/Project:", s: { font: { bold: true } } },
      { v: selectedDetails.branchProjectData },
      { v: "S.D.P.:", s: { font: { bold: true } } },
      { v: selectedDetails.sdpData },
      { v: "Area:", s: { font: { bold: true } } },
      { v: selectedDetails.areaData },
    ];

    const servicesRow = [
      { v: "" },
      { v: "Service Category:", s: { font: { bold: true } } },
      { v: selectedDetails.serviceCategoryData },
      { v: "Service Sub-Category:", s: { font: { bold: true } } },
      { v: selectedDetails.serviceSubCategoryData },
      { v: "Services:", s: { font: { bold: true } } },
      { v: selectedDetails.servicesData },
    ];

    const spacingRow = [{ v: "" }];

    /* ================= HEADER ROW ================= */
    const staticHeaders = [
      "S.No",
      "Branch",
      "SDP",
      "Area",
      "Service",
      "Project",
    ];

    const dynamicHeaders = ageGroups.flatMap((age) => [
      `Female ${age}`,
      `Male ${age}`,
      `Other ${age}`,
    ]);

    const headerRow = [...staticHeaders, ...dynamicHeaders, "Total"].map(
      (col) => ({
        v: col,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "center" },
        },
      })
    );

    /* ================= COLUMN TOTALS INIT ================= */
    const columnTotals = {};

    ageGroups.forEach((age) => {
      columnTotals[`Female${age}`] = 0;
      columnTotals[`Male${age}`] = 0;
      columnTotals[`Other${age}`] = 0;
    });

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((rowData, index) => {
      const isAlternate = index % 2 === 1;
      const baseStyle = isAlternate
        ? { fill: { fgColor: { rgb: "F2F2F2" } } }
        : {};

      let rowTotal = 0;

      ageGroups.forEach((age) => {
        const female = Number(rowData[`FemaleAge${age}`] || 0);
        const male = Number(rowData[`MaleAge${age}`] || 0);
        const other = Number(rowData[`OtherAge${age}`] || 0);

        columnTotals[`Female${age}`] += female;
        columnTotals[`Male${age}`] += male;
        columnTotals[`Other${age}`] += other;

        rowTotal += female + male + other;
      });

      const row = [
        index + 1,
        rowData.Branch,
        rowData.SDP_en,
        rowData.AreaName_en,
        rowData.Services_en,
        rowData.ProjectName_en,
        ...ageGroups.flatMap((age) => [
          Number(rowData[`FemaleAge${age}`] || 0),
          Number(rowData[`MaleAge${age}`] || 0),
          Number(rowData[`OtherAge${age}`] || 0),
        ]),
        rowTotal,
      ];

      return row.map((cell) => ({
        v: cell,
        t: typeof cell === "number" ? "n" : "s",
        s: {
          ...baseStyle,
          alignment:
            typeof cell === "number"
              ? { horizontal: "right" }
              : { horizontal: "left" },
          numFmt: typeof cell === "number" ? "0" : undefined,
        },
      }));
    });

    /* ================= TOTAL ROW ================= */
    const totalsRowStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: "E0E0E0" } },
    };

    const totalsRow = [
      "",
      "",
      "",
      "",
      "",
      "Total",
      ...ageGroups.flatMap((age) => [
        columnTotals[`Female${age}`],
        columnTotals[`Male${age}`],
        columnTotals[`Other${age}`],
      ]),
      Object.values(columnTotals).reduce((sum, val) => sum + val, 0),
    ].map((cell) => ({
      v: cell,
      t: typeof cell === "number" ? "n" : "s",
      s: {
        ...totalsRowStyle,
        alignment:
          typeof cell === "number"
            ? { horizontal: "right" }
            : { horizontal: "left" },
        numFmt: typeof cell === "number" ? "0" : undefined,
      },
    }));

    /* ================= COMBINE ALL ROWS ================= */
    const wsData = [
      titleRow,
      dateRangeRow,
      branchRow,
      servicesRow,
      spacingRow,
      headerRow,
      ...dataRows,
      totalsRow,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = headerRow.map(() => ({ width: 18 }));

    /* ================= APPLY BORDERS ================= */
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };
      }
    }

    /* ================= SAVE FILE ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Age&Gender - SRH.xlsx");
  };

  const handleExportDHIS = async () => {
    const createdBy = sessionStorage.getItem("createdBy");

    try {
      const dateRange = {
        fromDate: fromDate,
        toDate: toDate,
      };

      const selectedOptionsData = {
        branchProjectData:
          branchProjectNamesList.length > 0
            ? branchProjectNamesList.toString()
            : branchName,
        sdpData: sdpNamesList.toString(),
        areaData: areaNamesList.toString(),
        serviceCategoryData: serviceCategoryNameList.toString(),
        serviceSubCategoryData: serviceSubCategoryNameList.toString(),
        servicesData: serviceNameList.toString(),
      };


      if (!bindAgeGenderDHIS2SRHData || bindAgeGenderDHIS2SRHData.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "AGE GENDER DHIS2 SRH REPORT",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: null,
            description: "No data available to export",
          },
          "Log/IUDLog"
        );

        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });

        return;
      }

      // ✅ SUCCESS LOG
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "AGE GENDER  SRH REPORT",
          action: "EXCEL EXPORT",
          status: "SUCCESS",
          tableName: null,
          description: `Age Gender DHIS2 SRH Report Excel exported successfully. Total Records: ${bindAgeGenderDHIS2SRHData.length}`,
        },
        "Log/IUDLog"
      );

      // ✅ EXPORT
      exportDataDHIS(
        ageGenderDHIS2SRHReportHeader.map((column) => column.title),
        bindAgeGenderDHIS2SRHData,
        dateRange,
        selectedOptionsData
      );
    } catch (error) {
      console.error("Export error", error);

      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "AGE GENDER  SRH REPORT",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: null,
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog"
      );

      toast.error("Failed to export Excel", {
        duration: 1500,
        position: "top-center",
      });
    }
  };

  const exportDataDHIS = (columns, rows, dateRange, selectedDetails) => {
    const ageGroups = [
      "0to9", "10to14", "15to19", "20to24", "25to29",
      "30to34", "35to39", "40to44", "45to49", "50andAbove",
    ];

    // Order of the 3 rows per record: [label shown in sheet, prefix used in API data]
    const genders = [
      { label: "Male", key: "Male" },
      { label: "Female", key: "Female" },
      { label: "Other", key: "Other" },
    ];

    const STATIC_COLS = 6; // S.No..Project (merged across 3 rows)

    /* ================= TITLE / DATE / FILTER ROWS ================= */
    const titleRow = [
      {
        v: "Age&Gender - SRH",
        s: { font: { bold: true, sz: 16 }, alignment: { horizontal: "left" } },
      },
    ];

    const dateRangeRow = [
      { v: "" },
      { v: "From Date:", s: { font: { bold: true } } },
      { v: formatDate(dateRange.fromDate) },
      { v: "To Date:", s: { font: { bold: true } } },
      { v: formatDate(dateRange.toDate) },
    ];

    const branchRow = [
      { v: "" },
      { v: "Branch/Project:", s: { font: { bold: true } } },
      { v: selectedDetails.branchProjectData },
      { v: "S.D.P.:", s: { font: { bold: true } } },
      { v: selectedDetails.sdpData },
      { v: "Area:", s: { font: { bold: true } } },
      { v: selectedDetails.areaData },
    ];

    const servicesRow = [
      { v: "" },
      { v: "Service Category:", s: { font: { bold: true } } },
      { v: selectedDetails.serviceCategoryData },
      { v: "Service Sub-Category:", s: { font: { bold: true } } },
      { v: selectedDetails.serviceSubCategoryData },
      { v: "Services:", s: { font: { bold: true } } },
      { v: selectedDetails.servicesData },
    ];

    const spacingRow = [{ v: "" }];

    /* ================= HEADER ROW ================= */
    const headerTitles = [
      "S.No", "Branch", "SDP", "Area", "Service", "Project",
      "Gender",
      ...ageGroups,
      "Total",
    ];

    const headerRow = headerTitles.map((col) => ({
      v: col,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "center", vertical: "center" },
      },
    }));

    /* ================= COLUMN TOTALS ================= */
    const columnTotals = {};
    ageGroups.forEach((age) => (columnTotals[age] = 0));
    let grandTotal = 0;

    /* ================= DATA ROWS (3 rows per record) ================= */
    const dataRows = [];
    const merges = [];
    const dataStartRow = 6; // 0-based index: rows 0-5 are title..header

    rows.forEach((rowData, index) => {
      const isAlternate = index % 2 === 1;
      const baseStyle = isAlternate ? { fill: { fgColor: { rgb: "F2F2F2" } } } : {};

      const startRow = dataStartRow + index * 3;
      merges.push({
        s: { r: startRow, c: 0 },
        e: { r: startRow + 2, c: STATIC_COLS - 1 },
      }); // placeholder, replaced below by per-column merges

      genders.forEach((g, gIdx) => {
        const isFirst = gIdx === 0;

        // Static columns: value only on first row; empty (but styled) cells on the rest
        const staticValues = [
          index + 1,
          rowData.Branch,
          rowData.SDP_en,
          rowData.AreaName_en,
          rowData.Services_en,
          rowData.ProjectName_en,
        ];

        const staticCells = staticValues.map((val) => ({
          v: isFirst ? val : "",
          t: isFirst && typeof val === "number" ? "n" : "s",
          s: {
            ...baseStyle,
            alignment: { horizontal: "center", vertical: "center", wrapText: true },
          },
        }));

        // Gender cell
        const genderCell = {
          v: g.label,
          t: "s",
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        };

        // Age cells + row total
        let rowTotal = 0;
        const ageValues = ageGroups.map((age) => {
          const val = Number(rowData[`${g.key}Age${age}`] || 0);
          columnTotals[age] += val;
          rowTotal += val;
          return val;
        });
        grandTotal += rowTotal;

        const numCell = (val) => ({
          v: val,
          t: "n",
          s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" },
        });

        dataRows.push([
          ...staticCells,
          genderCell,
          ...ageValues.map(numCell),
          numCell(rowTotal),
        ]);
      });
    });

    // Build one merge per static column per record (A..F, 3 rows each)
    merges.length = 0;
    rows.forEach((_, index) => {
      const startRow = dataStartRow + index * 3;
      for (let c = 0; c < STATIC_COLS; c++) {
        merges.push({ s: { r: startRow, c }, e: { r: startRow + 2, c } });
      }
    });

    /* ================= TOTAL ROW ================= */
    const totalsRowStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: "E0E0E0" } },
    };

    const totalsRow = [
      "", "", "", "", "", "Total", "",
      ...ageGroups.map((age) => columnTotals[age]),
      grandTotal,
    ].map((cell) => ({
      v: cell,
      t: typeof cell === "number" ? "n" : "s",
      s: {
        ...totalsRowStyle,
        alignment: {
          horizontal: typeof cell === "number" ? "right" : "left",
        },
        numFmt: typeof cell === "number" ? "0" : undefined,
      },
    }));

    /* ================= COMBINE ================= */
    const wsData = [
      titleRow,
      dateRangeRow,
      branchRow,
      servicesRow,
      spacingRow,
      headerRow,
      ...dataRows,
      totalsRow,
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= MERGES + COLUMN WIDTHS ================= */
    ws["!merges"] = merges;
    ws["!cols"] = headerRow.map(() => ({ width: 18 }));

    /* ================= BORDERS ================= */
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };
      }
    }

    /* ================= SAVE ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Age&Gender - SRH.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });
    const logoWidth = 30;
    const logoHeight = 14;
    doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);

    const headers = ageGenderDHIS2SRHReportHeader.map((column) => column.title);

    const data = bindAgeGenderDHIS2SRHData.map((rowData, index) => {
      return [
        index + 1,
        rowData.Services_en,
        rowData.FemaleAge0to9,
        rowData.MaleAge0to9,
        rowData.OtherAge0to9,
        rowData.FemaleAge10to14,
        rowData.MaleAge10to14,
        rowData.OtherAge10to14,
        rowData.FemaleAge15to19,
        rowData.MaleAge15to19,
        rowData.OtherAge15to19,
        rowData.FemaleAge20to24,
        rowData.MaleAge20to24,
        rowData.OtherAge20to24,
        rowData.FemaleAge25to29,
        rowData.MaleAge25to29,
        rowData.OtherAge25to29,
        rowData.FemaleAge30to34,
        rowData.MaleAge30to34,
        rowData.OtherAge30to34,
        rowData.FemaleAge35to39,
        rowData.MaleAge35to39,
        rowData.OtherAge35to39,
        rowData.FemaleAge40to44,
        rowData.MaleAge40to44,
        rowData.OtherAge40to44,
        rowData.FemaleAge45to49,
        rowData.MaleAge45to49,
        rowData.OtherAge45to49,
        rowData.FemaleAge50andAbove,
        rowData.MaleAge50andAbove,
        rowData.OtherAge50andAbove,
      ];
    });

    // Create the table with headers and data
    doc.autoTable({
      head: [headers],
      body: data,
      startY: 30,
      styles: {
        fontSize: 7, // Reduced font size
        lineColor: "black",
        lineWidth: 0.2,
        halign: "center", // Align text to center
        valign: "middle", // Align text vertically in the middle
        cellPadding: 2, // Add padding to cells
        overflow: "linebreak", // Allow text to wrap within cells
      },
      headStyles: {
        fillColor: "#2d2d6e",
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray color for alternate rows
      },
      columnStyles: {
        0: { cellWidth: 10 }, // Index column
        1: { cellWidth: "auto" }, // Auto adjust width
        2: { cellWidth: "auto" }, // Auto adjust width
        3: { cellWidth: "auto" }, // Auto adjust width
        4: { cellWidth: "auto" }, // Auto adjust width
        5: { cellWidth: "auto" }, // Auto adjust width
        6: { cellWidth: "auto" }, // Auto adjust width
        7: { cellWidth: "auto" }, // Auto adjust width
        8: { cellWidth: "auto" }, // Auto adjust width
        9: { cellWidth: "auto" }, // Auto adjust width
        10: { cellWidth: "auto" }, // Age
        11: { cellWidth: "auto" }, // Gender
        12: { cellWidth: "auto" }, // Auto adjust width
        13: { cellWidth: "auto" }, // Auto adjust width
        14: { cellWidth: "auto" }, // Auto adjust width
        15: { cellWidth: "auto" }, // Auto adjust width
        16: { cellWidth: "auto" }, // Index column
        17: { cellWidth: "auto" }, // Auto adjust width
        18: { cellWidth: "auto" }, // Auto adjust width
        19: { cellWidth: "auto" }, // Auto adjust width
        20: { cellWidth: "auto" }, // Auto adjust width
        21: { cellWidth: "auto" }, // Auto adjust width
        22: { cellWidth: "auto" }, // Auto adjust width
        23: { cellWidth: "auto" }, // Auto adjust width
        24: { cellWidth: "auto" }, // Auto adjust width
        25: { cellWidth: "auto" }, // Auto adjust width
        26: { cellWidth: "auto" }, // Age
        27: { cellWidth: "auto" }, // Gender
        28: { cellWidth: "auto" }, // Auto adjust width
        29: { cellWidth: "auto" }, // Auto adjust width
        30: { cellWidth: "auto" }, // Auto adjust width
        31: { cellWidth: "auto" }, // Auto adjust width
      },
    });

    doc.save("Age&Gender - DHIS2-SRH.pdf");
  };
  const BranchProjectFetchData = async () => {
    try {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };

      const locationResponse = await BindPostAPI([data], "LocationAPI/BindLocation");

      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindBranchProjectDD(locationData);
    } catch (error) { }
  };

  useEffect(() => {
    const getSelectedServiceSubCategory = async () => {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };

      const serviceSubCategoryResponse = await BindPostAPI([data],
        "ServicesSubCategoryAPI/BindServicesSubCategory"
      );
      setGetServiceSubCDatas(serviceSubCategoryResponse.data.Table);
    };
    // Bind service Dropdown datas
    const getSelectedServices = async () => {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };
      const serviceSubCategoryResponse = await BindPostAPI([data],
        "ServicesMasterAPI/BindServices"
      );
      setGetServicesDatas(serviceSubCategoryResponse.data.Table);
    };

    getSelectedServices();

    getSelectedServiceSubCategory();
  }, []);

  const serviceCategoryDD = async () => {
    try {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };
      const serviceCategoryResponse = await BindPostAPI([data],
        "ServicesCategoryAPI/BindServicesCategory"
      );

      const serviceCategoryData = serviceCategoryResponse.data.Table.map(
        (item) => ({
          value: item.MstServicesCategoryId,
          label: item.ServicesCategory_en,
        })
      );

      setBindServiceCategory(serviceCategoryData);
    } catch (error) {
      // Handle API call errors (e.g., show an error message)
    }
  };
  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);

  const ageGenderFieldsChange = (value, name) => {
    setShowTable(false);
    setAgeGenderFields({
      ...ageGenderFields,
      [name]: value,
    });
  };

  useEffect(() => {
    if (ageGenderFields.branchProject) {
      try {
        const getSelectedSDP = async () => {
          const userProfileDatas = userProfileState.userProfile;
          const [profile] = userProfileDatas;
          const data = {
            mstOrganizationStructureId: profile.MstOrganizationId,
            mstBranchId: profile.MstLocationId,
            mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
            mstUserId: profile.MstUserId,
            mstRoleId: profile.MstRoleId,
            languageCode: "en",
          };


          const locationResponse = await BindPostAPI([data], "SDPAPI/GetSDP");

          setGetSDPDatas(locationResponse.data.Table);

          if (userProfileDatas && userProfileDatas[0]) {
            const sdpLabels = locationResponse.data.Table.filter((item) =>
              ageGenderFields.branchProject.includes(
                parseInt(item.MstLocationId)
              )
            ).map((item) => ({
              MstSDPId: item.MstSDPId,
              SDP_en: item.SDP_en,
            }));

            const sdpSelected = sdpLabels.map((SD) => ({
              value: SD.MstSDPId,
              label: SD.SDP_en,
            }));

            if (
              userProfileDatas[0].MstOrganizationId == 1 ||
              userProfileDatas[0].MstOrganizationId == 2
            ) {
              setBindSDP(sdpSelected);
            } else {
              const allSDPIds = userProfileDatas[0]?.AllSDP;
              const sdpId = userProfileDatas[0]?.MstSDPId;
              if (allSDPIds && Array.isArray(allSDPIds)) {
                const filteredSdpSelected = sdpSelected.filter((sdp) =>
                  allSDPIds.includes(sdp.value)
                );
                setBindSDP(filteredSdpSelected);
              }
              if (sdpId) {
                const filteredSdpSelected = sdpSelected.filter((sdp) =>
                  Array.isArray(sdpId)
                    ? sdpId.includes(sdp.value)
                    : sdpId === sdp.value
                );

                setBindSDP(filteredSdpSelected);
              }
            }
          }
        };

        getSelectedSDP();
      } catch (e) { }
    }
  }, [
    ageGenderFields.branchProject ? ageGenderFields.branchProject : undefined,
    userProfileDatas ? userProfileDatas : undefined,
  ]);

  useEffect(() => {
    if (ageGenderFields.sdp) {
      try {
        const getSelectedArea = async () => {
          const userProfileDatas = userProfileState.userProfile;
          const [profile] = userProfileDatas;
          const data = {
            mstOrganizationStructureId: profile.MstOrganizationId,
            mstBranchId: profile.MstLocationId,
            mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
            mstUserId: profile.MstUserId,
            mstRoleId: profile.MstRoleId,
            languageCode: "en",
          };


          const locationResponse = await BindPostAPI([data], "AreaAPI/GetArea");
          setGetAreaDatas(locationResponse.data.Table);

          const areaLabels = locationResponse.data.Table.filter((item) =>
            ageGenderFields.sdp.includes(item.MstSDPId)
          ).map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

          const areaSelected = areaLabels.map((AR) => ({
            value: AR.MstAreaId,
            label: AR.AreaName_en,
          }));

          setBindAreaDD(areaSelected);
        };

        getSelectedArea();
      } catch (e) { }
    }
  }, [ageGenderFields.sdp ? ageGenderFields.sdp : undefined]);

  useEffect(() => {
    // Bind Services Sub Category Dropdown datas

    const serviceSubCategorySelectedValue = ageGenderFields.serviceCategory;
    setBindServiceSubCategory([]);
    if (serviceSubCategorySelectedValue) {
      const serviceSubCategoryLabels = getServiceSubCDatas
        .filter((item) =>
          serviceSubCategorySelectedValue.includes(item.MstServicesCategoryId)
        )
        .map((item) => ({
          MstServicesSubCategoryId: item.MstServicesSubCategoryId,
          ServicesSubCategory_en: item.ServicesSubCategory_en,
        }));

      const servicesSubCategorySelected = serviceSubCategoryLabels.map(
        (AR) => ({
          value: AR.MstServicesSubCategoryId,
          label: AR.ServicesSubCategory_en,
        })
      );
      setBindServiceSubCategory(servicesSubCategorySelected);
    } else {
    }
  }, [ageGenderFields.serviceCategory]);

  useEffect(() => {
    // Bind Services Dropdown datas

    const selectedSubCategories = ageGenderFields.serviceSubCategory;
    setBindServicesName([]);
    if (selectedSubCategories.length > 0) {
      const servicesLabels = getServicesData
        .filter((item) =>
          selectedSubCategories.includes(item.MstServicesSubCategoryId)
        )
        .map((item) => ({
          MstServicesId: item.MstServicesId,
          Services_en: item.Services_en,
        }));

      const servicessSelected = servicesLabels.map((AR) => ({
        value: AR.MstServicesId,
        label: AR.Services_en,
      }));
      setBindServicesName(servicessSelected);
    } else {
      // Handle the case when no sub-categories are selected
      setBindServicesName([]);
    }
  }, [ageGenderFields.serviceSubCategory]);

  return (
    <MainLayout pageName="4">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Age&Gender - SRH`}</div>
            </div>
            <div className={mainTable.grid3}>
              {userProfileDatas[0]?.MstOrganizationId == 1 && (
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Branch/Project"
                    filteredOptions={bindBranchProjectDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      ageGenderFields.branchProject?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="branchProject"
                    selectedOptions={ageGenderFields.branchProject}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      ageGenderFieldsChange(e, "branchProject");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {ageGenderFieldsError.branchProjectError && (
                    <span className="text-red-500">
                      {ageGenderFieldsError.branchProjectError}
                    </span>
                  )}
                </div>
              )}
              {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                userProfileDatas[0]?.MstOrganizationId == 3) && (
                  <InputText
                    inputType="text"
                    title="Branch/Project"
                    classStar="text-red-500"
                    name="branchName"
                    disabled="true"
                    content={branchName}
                    controlFunc={(e) => setBranchName(e.target.value)}
                  />
                )}
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="SDP"
                  filteredOptions={bindSDP}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.sdp?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="sdp"
                  selectedOptions={ageGenderFields.sdp}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "sdp");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.sdpError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.sdpError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Area"
                  filteredOptions={bindArea}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.area?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="area"
                  selectedOptions={ageGenderFields.area}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "area");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.areaError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.areaError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Service Category"
                  filteredOptions={bindServiceCategory}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.serviceCategory?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="serviceCategory"
                  selectedOptions={ageGenderFields.serviceCategory}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "serviceCategory");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.serviceCategoryError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.serviceCategoryError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Service Sub-Category"
                  filteredOptions={bindServiceSubCategory}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.serviceSubCategory?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="serviceSubCategory"
                  selectedOptions={ageGenderFields.serviceSubCategory}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "serviceSubCategory");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.serviceSubCategoryError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.serviceSubCategoryError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Services"
                  filteredOptions={bindServicesName}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.servicesName?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="servicesName"
                  selectedOptions={ageGenderFields.servicesName}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "servicesName");
                  }}
                />
                {ageGenderFieldsError.servicesNameError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.servicesNameError}
                  </span>
                )}
              </div>
              <AutoDropDown
                title="Project"
                options={bindProjectDD}
                placeholder="Select"
                name="project"
                selectedOption={bindProjectDD.find((x) => x.value == project)}
                Class="custom-class"
                tabIndex="1"
                controlFunc={(value, e) => {
                  setProject(value.value);
                }}
              />
            </div>
            <div class={mainTable.grid3}>
              <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => {
                  setFromDate(e.target.value);
                  setShowTable(false);
                }}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => {
                  setToDate(e.target.value);
                  setShowTable(false);
                }}
              />
              <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable &&
          (bindAgeGenderDHIS2SRHData.length > 0 ? (
            <div className=" ">
              <ReportGridPage
                title=""
                header={ageGenderDHIS2SRHReportHeader}
                records={bindAgeGenderDHIS2SRHData}
                handleExport={handleExport}
                DHISButton={true}
                handleExportDHIS={handleExportDHIS}
                handlePDF={downloadPDF}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          ))}
      </div>
    </MainLayout>
  );
};

export default AgeGenderDHIS2SRH;
